import artists from "./artists.json";

// Single source of truth: artists.json is also read by the backend news
// aggregator (/app/backend/news.py) so new artists automatically get news
// coverage with no extra configuration.
export const ARTISTS = artists;
